import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { fetchTips } from 'catalog/actions/tip';
import { createEntityNode } from 'catalog/actions/node';
import NodeSourcePage from './NodeSourcePage';

const mapStateToProps = state => ({
  entities: state.catalog.tips,
  info:
    'Sélectionnez une astuce technique pour créer un noeud à partir de cette dernière.',
  link: '/tips/new',
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchEntities: () => dispatch(fetchTips()),
  createNode: tip =>
    dispatch(
      createEntityNode(ownProps.catalog, ownProps.params.id, 'tip', tip)
    ),
  redirectToParent: () => dispatch(replace(`/nodes/${ownProps.params.id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeSourcePage);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeTipsPage.js